import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../common';

@Injectable({
  providedIn: 'root'
})
export class SearchGlobalService {
  private apiUrlRec = `${API_URL}/api/ICDSmartSearch/recommend`; // Thay đổi URL API tìm kiếm tại đây
  private apiUrlApp = `${API_URL}/api/ICDSmartSearch/apps`; 
  private apiSearch=`${API_URL}/api/ICDSmartSearch/search`;
  private apiEvaluate=`${API_URL}/api/ICDSmartSearch/evaluate`;
  private apiGetEvaluate=`${API_URL}/api/ICDSmartSearch/get_evaluates`;
  constructor(private http: HttpClient) { 
  }

  rec(query: string): Observable<any[]> {
    const url = `${this.apiUrlRec}?q=${query.trim()}`;
    return this.http.get<any[]>(url);
  }

  search(param: string,app:string, display: string): Observable<any[]>{
    const headers = new HttpHeaders({
      'X-Client-IP': localStorage.getItem('client_ip') || ''
    });
    const url=`${this.apiSearch}?q=${param.trim()}&app=${app==='all' || display === 'tree'?"":app}&tree=${display==='tree' ? 1 : 0}`;
    return this.http.get<any[]>(url, { headers: headers });
  }

  evaluate(id:number,index:number,like:number): Observable<any[]>{
    let csrftoken: string = ''; // Assigning a default value
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, 10) === 'csrftoken' + '=') {
                    csrftoken = decodeURIComponent(cookie.substring(10));
                    break;
                }
            }
        }
        const csrfToken = csrftoken;
    const url=`${this.apiEvaluate}?id=${id}&index=${index}&like=${like}`
    return this.http.post<any[]>(url,{} ,{
      headers: { 'X-CSRFToken': csrfToken },
  });
  }
  getEvaluate(id:number): Observable<any[]>{
    let csrftoken: string = ''; // Assigning a default value
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, 10) === 'csrftoken' + '=') {
                    csrftoken = decodeURIComponent(cookie.substring(10));
                    break;
                }
            }
        }
        const csrfToken = csrftoken;
    const url=`${this.apiGetEvaluate}?id=${id}`
    return this.http.post<any[]>(url,[],{
      headers: { 'X-CSRFToken': csrfToken },
  });
  }
  getApp(): Observable<any[]>{
    return this.http.get<any[]>(this.apiUrlApp);

  }
}
